var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-combobox',_vm._b({attrs:{"chips":"","multiple":"","return-object":""},on:{"input":_vm.input},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var attrs = ref.attrs;
var item = ref.item;
var select = ref.select;
var selected = ref.selected;
return [_c('v-chip',_vm._b({attrs:{"input-value":selected,"close":""},on:{"click":select,"click:close":function($event){return _vm.remove(item)}}},'v-chip',attrs,false),[_vm._v(_vm._s(item))])]}}])},'v-combobox',{ value: _vm.value, label: _vm.label, loading: _vm.loading, items: _vm.items, itemText: _vm.itemText, itemValue: _vm.itemValue, clearable: _vm.clearable },false))}
var staticRenderFns = []

export { render, staticRenderFns }